export enum EventTypes {
    REALITY_CHECK = 'realityCheck', // uses before placing a bet
    BALANCE_CHECK = 'balanceCheck',
    NEW_HEIGHT = 'newHeight',
    SCROLL_TO = 'scrollTo',
    IFRAME_TOP = 'iframeTop',
    VIEW_PORT = 'getViewPort',
    SUBSCRIBE_SCROLL = 'subscribeScroll',
    UNSUBSCRIBE_SCROLL = 'unsubscribeScroll',
    ON_SCROLL = 'onScroll',
}
